import { render } from "./Upload.vue?vue&type=template&id=d31c4e30"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
script.render = render

export default script